import { cn } from '@@/lib/utils';
import React from 'react';

interface LabeledComponentProps {
  label: React.ReactNode;
  className?: string;
  children: React.ReactNode;
}

export const LabeledComponent = ({ label, children, className }: LabeledComponentProps) => {
  return (
    <div className={cn('flex flex-col gap-2 min-w-0', className)}>
      {label && (
        <label className='text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-gray-100 pl-1'>
          {label}
        </label>
      )}
      {children}
    </div>
  );
};
